// brand.config.js — ÚNICO lugar donde se define la identidad de cada PWA.
// Se elige con REACT_APP_BRAND=pwa1|pwa2 (si no está definida, usa pwa1).
// Es CommonJS a propósito: lo leen tanto la app (webpack) como scripts/apply-brand.js (Node).

const brands = {
  // PWA #1 — identidad actual. No cambiar valores: debe verse idéntica a producción.
  pwa1: {
    id: 'pwa1',
    name: 'Manrique Importadora',
    shortName: 'Manrique',
    legalName: 'Manrique Importadora',
    appName: 'Manrique App',
    // Nombre que ve el cliente en el texto de compartir / WhatsApp de la cotización
    shareName: 'Manrique Importadora',
    tagline: 'Productos de Belleza',
    description: 'Aplicación de cotizaciones y escaneo de productos de belleza',
    logoUrl: 'https://customer-assets.emergentagent.com/job_manrique-beauty/artifacts/b6wvcecd_LogoPngManrique.png',
    colors: {
      primary: '#D4A5A5',
      hover: '#C29090',
      accent: '#1A1A1A',
      bg: '#F9FAFB',
      // Fondo de la pantalla de login (CSS completo). En pwa1 equivale a from-gray-50 to-gray-100.
      bgLogin: 'linear-gradient(to bottom, #F9FAFB, #F3F4F6)',
      text: '#1A1A1A',
      onPrimary: '#1A1A1A',
      band: '#1A1A1A',
      bandHover: '#2A2A2A',
    },
    // Si es true, también se recolorean las variables HSL de shadcn (--primary, --ring…).
    // En pwa1 se dejan los valores de index.css para no alterar nada.
    overrideShadcn: false,
    fonts: {
      head: "'Playfair Display', serif",
      body: "'DM Sans', sans-serif",
      // Clase Tailwind `font-serif` (la usan los títulos). En pwa1 es la pila por defecto de Tailwind.
      serif: "ui-serif, Georgia, Cambria, 'Times New Roman', Times, serif",
      googleUrl: 'https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;700&family=Playfair+Display:wght@400;600&display=swap',
    },
    pdf: {
      title: 'MANRIQUE IMPORTADORA',
      subtitle: 'Productos de Belleza',
      filePrefix: 'Manrique',
    },
    // Íconos del manifest e <head>. pwa1 conserva el PNG remoto actual.
    manifest: {
      backgroundColor: '#FFFFFF',
      themeColor: '#D4A5A5',
      icons: [
        { src: 'https://customer-assets.emergentagent.com/job_manrique-beauty/artifacts/b6wvcecd_LogoPngManrique.png', sizes: '192x192', type: 'image/png', purpose: 'any maskable' },
        { src: 'https://customer-assets.emergentagent.com/job_manrique-beauty/artifacts/b6wvcecd_LogoPngManrique.png', sizes: '512x512', type: 'image/png', purpose: 'any maskable' },
      ],
      favicon: 'https://customer-assets.emergentagent.com/job_manrique-beauty/artifacts/b6wvcecd_LogoPngManrique.png',
      appleTouchIcon: 'https://customer-assets.emergentagent.com/job_manrique-beauty/artifacts/b6wvcecd_LogoPngManrique.png',
    },
    // Subdominio / API (solo informativo para scripts; el build usa REACT_APP_BACKEND_URL)
    domain: 'app.manrique.pro',
  },

  // PWA #2 — propuesta B «Índigo y Coral» (brand-review/propuestas.html).
  // Si cambia el nombre, actualizarlo en este bloque y regenerar logo/íconos con
  // scripts/gen-pwa2-assets.mjs (el logo usa shortName).
  pwa2: {
    id: 'pwa2',
    name: 'Manrique Ventas 2',
    shortName: 'Manrique 2',
    legalName: 'Manrique Ventas 2',
    appName: 'Manrique Ventas 2',
    shareName: 'Manrique Importadora',
    tagline: 'Cotizaciones y escaneo',
    description: 'Aplicación de cotizaciones y escaneo de productos',
    logoUrl: '/brand/pwa2/logo.svg',
    colors: {
      primary: '#2B3A8C',
      hover: '#1F2B6B',
      accent: '#F26B4F',
      bg: '#EEF1FB',
      bgLogin: 'linear-gradient(160deg, #E3E8FA 0%, #EEF1FB 55%, #FCEBE5 100%)',
      text: '#0E1330',
      onPrimary: '#FFFFFF',
      band: '#1F2B6B',
      bandHover: '#2B3A8C',
    },
    overrideShadcn: true,
    fonts: {
      head: "'Archivo', sans-serif",
      body: "'Archivo', sans-serif",
      serif: "'Archivo', sans-serif",
      googleUrl: 'https://fonts.googleapis.com/css2?family=Archivo:wght@400;500;700;800&display=swap',
    },
    pdf: {
      title: 'MANRIQUE IMPORTADORA',
      subtitle: 'Productos de Belleza',
      filePrefix: 'Manrique_Importadora',
      showMark: true, // dibuja la «M» vectorial (mark) en el encabezado del PDF
    },
    // Geometría de la «M» (dos montañas + barra base). Unidades 113 x 54. La usan
    // scripts/gen-pwa2-assets.mjs (logo e íconos) y el encabezado del PDF.
    mark: {
      width: 113,
      height: 54,
      shapes: [
        [[45, 0], [72, 54], [63, 54], [45, 18], [27, 54], [18, 54]],
        [[71, 0], [98, 54], [89, 54], [71, 18], [53, 54], [44, 54]],
        [[44, 50], [72, 50], [72, 54], [44, 54]],
      ],
      accent: [[58, 43.6], [54.7, 50.2], [61.3, 50.2]], // triángulo interior (coral)
    },
    manifest: {
      backgroundColor: '#EEF1FB',
      themeColor: '#2B3A8C',
      icons: [
        { src: '/brand/pwa2/icon-192.png', sizes: '192x192', type: 'image/png', purpose: 'any' },
        { src: '/brand/pwa2/icon-512.png', sizes: '512x512', type: 'image/png', purpose: 'any' },
        { src: '/brand/pwa2/maskable-512.png', sizes: '512x512', type: 'image/png', purpose: 'maskable' },
      ],
      favicon: '/brand/pwa2/icon-192.png',
      appleTouchIcon: '/brand/pwa2/maskable-512.png',
    },
    domain: 'app2.manrique.pro',
  },
};

const brandId = process.env.REACT_APP_BRAND && brands[process.env.REACT_APP_BRAND]
  ? process.env.REACT_APP_BRAND
  : 'pwa1';

module.exports = { brands, brand: brands[brandId], brandId };
